import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  Search,
  Selection,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import React, { useCallback, useEffect, useState } from "react";

import { Header } from "../components";
import Modal1 from "../components/Modal1";

import { BsBoxSeam } from "react-icons/bs";
import { MdOutlineSupervisorAccount } from "react-icons/md";
import { useParams } from "react-router-dom";
import RedevanceCard from "../components/RedevanceCard";
import { useStateContext } from "../contexts/ContextProvider";
import { redevancessGrid } from "../data/dummy";
import { usePostPaymentMutation } from "../redux/paymentService";
import {
  useGetRedevanceQuery,
  useLazyGetRedevanceQuery,
  useLazySearchRedevancesByRedevableNameQuery,
} from "../redux/redevanceService";
import Pagination from "../components/Pagination";
import { toast } from "react-toastify";

const headerTemplate = (props) => (
  <div>
    <p className="font-bold text-base">{props?.headerText || "Action"}</p>
  </div>
);

const earningData = [
  {
    icon: <MdOutlineSupervisorAccount />,
    amount: "39,354",
    percentage: "-4%",
    title: "Montant total",
    iconColor: "#03C9D7",
    iconBg: "#E5FAFB",
    pcColor: "red-600",
  },
  {
    icon: <BsBoxSeam />,
    amount: "4,396",
    percentage: "+23%",
    title: "Monantant payé",
    iconColor: "#fff",
    iconBg: "green-600",
    pcColor: "green-600",
  },
  {
    icon: <BsBoxSeam />,
    amount: "4,396",
    percentage: "+23%",
    title: "Monantant à payer",
    iconColor: "#fff",
    iconBg: "yellow-600",
    pcColor: "green-600",
  },
];

const Redevances = () => {
  const [getRedevances, { data, isLoading, isSuccess, isError }] =
    useLazyGetRedevanceQuery({
      page: 1,
      size: 50,
    });

    const [searchRedevances, { data: searchData }] = useLazySearchRedevancesByRedevableNameQuery()
  const { currentColor } = useStateContext();
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState();
  const [postPayment] = usePostPaymentMutation();
  const [filter, setFilter] = useState("all");
  const [redevances, setRedevances] = useState();
  const [fetchedPage, setFetchedPage] = useState({ page: 1, size: 50 });
  const [searchTerm, setSearchTerm] = useState("");

  const next = useCallback(() => {
    setFetchedPage((prev) => {
      const nextPage = prev.page + 1;
      getRedevances({ page: nextPage, size: prev.size })?.then((res) => {
        console.log("getRedevances response", res);
        setRedevances(
          res?.data?.groupedRedevances?.filter(
            (item) => item.name !== "Inconnu"
          )
        );
      });
      return { ...prev, page: nextPage };
    });
  }, [getRedevances]);

  const prev = useCallback(() => {
    setFetchedPage((prev) => {
      const prevPage = prev.page > 1 ? prev.page - 1 : 1;
      getRedevances({ page: prevPage, size: prev.size })?.then((res) => {
        console.log("getRedevances response", res);
        setRedevances(
          res?.data?.groupedRedevances?.filter(
            (item) => item.name !== "Inconnu"
          )
        );
      });
      return { ...prev, page: prevPage };
    });
  }, [getRedevances]);

  const params = useParams();
  console.log("params", params);

  // Debugging useEffect to track loading and success states
  useEffect(() => {
    console.log("isLoading:", isLoading);
    console.log("isSuccess:", isSuccess);
    console.log("isError:", isError);
  }, [isLoading, isSuccess, isError]);

  let grid;
  const toolbarClick = (args) => {
    if (grid && args.item.id === "Grid_excelexport") {
      grid.showSpinner();
      grid.excelExport();
    }
  };
  const excelExportComplete = () => {
    grid.hideSpinner();
  };

  const handlePayment = useCallback((status) => {
    console.log("item", selected);
    // localStorage.removeItem("redevance");
    if (localStorage.getItem("redevance")) {
      console.log("localStorage", localStorage.getItem("redevance"));
      const { id, attributes } = JSON.parse(localStorage.getItem("redevance"));
      console.log("id", id);
      const { montant, type } = attributes;
      const data = {
        redevance: id,
        montant: montant + (montant * 2.5) / 100,
        date_paiement: new Date().toISOString(),
        mode_paiement: "orange-money",
        type,
        date: new Date().toISOString(),
        status: status === "success" ? true : false,
        redevable: attributes?.redevable?.data.id,
        redevances: attributes.id,
        user: 1,
      };

      postPayment({ data }).then(
        (res) => {
          console.log("res", res);
          if (res?.data) {
            console.log("res", res?.data);
            window.open(
              `https://sandbox.orange-money.com/om/api/v1/transfer?token=${res?.data?.token}`,
              "_blank"
            );
          } else {
            console.log("error", res.error);
          }
          setShow(false);
          localStorage.removeItem("redevance");
        },
        (error) => {
          console.error("Error:", error);
          setShow(false);
        }
      );
    }
  });

  const [isPaymentLoading, setIsPaymentLoading] = useState(false);

  // Modifiez la fonction savePayment
  const savePayment = useCallback(
    (status) => {
      // Vérifiez si un paiement est déjà en cours
      if (isPaymentLoading) {
        console.log("Paiement déjà en cours...");
        return;
      }

      console.log("item", selected);
      // localStorage.removeItem("redevance");
      if (localStorage.getItem("redevance")) {
        console.log("localStorage", localStorage.getItem("redevance"));
        const { order_id, amount } = JSON.parse(
          localStorage.getItem("redevance")
        );

        setIsPaymentLoading(true); // Activez le loading

        const data = {
          redevance: +order_id.match(/U-(\d+)/)?.[1],
          redevable: +order_id.match(/R-(\d+)/)?.[1],
          montant: (amount + (amount * 2.5) / 100).toString(),
          date_paiement: new Date().toISOString(),
          mode_paiement: "orange-money",
          date: new Date().toISOString(),
          status: status === "success" ? true : false,
          user: JSON.parse(localStorage.getItem("auth"))?.user?.id || 1,
        };

        console.log("saving payment with data:", data);

        postPayment({ data })
          .then(
            (res) => {
              console.log("res", res);
              if (res?.data) {
                console.log("res", res?.data);
                toast.success(`Paiement effectué avec succès !`, {
                  position: "top-right",
                });
                setShow(false);
                localStorage.removeItem("redevance");
              } else {
                console.log("error", res.error);
                toast.error(
                  `Erreur lors du paiement : ${
                    res.error?.data?.message || "Veuillez réessayer plus tard."
                  }`,
                  { position: "top-right" }
                );
                setShow(false);
              }
            },
            (error) => {
              console.error("Error:", error);
              toast.error(
                `Erreur lors du paiement : ${
                  error?.data?.message || "Veuillez réessayer plus tard."
                }`,
                { position: "top-right" }
              );
              setShow(false);
            }
          )
          .finally(() => {
            setIsPaymentLoading(false); // Désactivez le loading dans tous les cas
          });
      }
    },
    [isPaymentLoading]
  );

  const handleShowModal = useCallback((props) => {
    console.log("props", props);
    setSelected(props);
    // localStorage.setItem("redevance", JSON.stringify(props));
    setShow(true);
  }, []);

  const paymentTemplate = (item) => (
    <div className="flex justify-center items-center">
      <button
        onClick={() => handleShowModal(item)}
        className="w-24 px-2 py-1 font-semibold text-white bg-orange-500 rounded-2xl">
        Payer
      </button>
    </div>
  );

  const search = (e) => {
    console.log("searchValue  000000", e)
    const searchValue = e.target.value.trim();
  
    console.log("searchValue", searchValue);
    
    // Debounce pour éviter trop d'appels API
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
  
    const searchTimeout = setTimeout(() => {
      if (searchValue) {
        getRedevances({ page: 1, size: 50, search: searchValue })
          .then((res) => {
            console.log("getRedevances response", res);
            setRedevances(
              res?.data?.groupedRedevances?.filter(
                (item) => item.name !== "Inconnu"
              )
            );
          })
          .catch((error) => {
            console.error("Error fetching redevances:", error);
            toast.error("Erreur lors de la recherche des redevances.", {
              position: "top-right",
            });
          });
      } else {
        getRedevances({ page: 1, size: 50 })
          .then((res) => {
            console.log("getRedevances response", res);
            setRedevances(
              res?.data?.groupedRedevances?.filter(
                (item) => item.name !== "Inconnu"
              )
            );
          })
          .catch((error) => {
            console.error("Error fetching redevances:", error);
            toast.error("Erreur lors de la récupération des redevances.", {
              position: "top-right",
            });
          });
      }
    }, 300); // Attendre 300ms après la dernière saisie
  };
  const excelQueryCellInfo = (args) => {
    console.log("excelQueryCellInfo", args);

    // Exclure la colonne Action de l'export
    if (args.column.headerText === "Action") {
      args.cancel = true;
      return;
    }

    if (args.column.headerText === "Nom") {
      args.hyperLink = {
        displayText: args.data?.attributes?.name,
      };
    }
    if (args.column.headerText === "Adresse") {
      args.hyperLink = {
        displayText:
          args.data?.redevances[0]?.attributes?.redevable?.data?.attributes
            ?.adresse_details,
      };
    }
    if (args.column.headerText === "Date d'ajout") {
      args.hyperLink = {
        displayText: new Date(
          args.data?.attributes?.createdAt
        ).toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
      };
    }
  };

  const filterData = useCallback(() => {
    console.log("data", data);
    const today = new Date();
    switch (filter) {
      case "today":
        return data?.groupedRedevances.filter((item) => {
          const itemDate = new Date(item.prochaineMensualite.date);
          return (
            itemDate.getDate() === today.getDate() &&
            itemDate.getMonth() === today.getMonth() &&
            itemDate.getFullYear() === today.getFullYear()
          );
        });
      case "week":
        const startOfWeek = new Date(
          today.setDate(today.getDate() - today.getDay())
        );
        const endOfWeek = new Date(
          today.setDate(today.getDate() - today.getDay() + 6)
        );
        return data?.groupedRedevances.filter((item) => {
          const itemDate = new Date(item.prochaineMensualite.date);
          return itemDate >= startOfWeek && itemDate <= endOfWeek;
        });
      case "month":
        return data?.groupedRedevances.filter((item) => {
          const itemDate = new Date(item.prochaineMensualite.date);
          return (
            itemDate.getMonth() === today.getMonth() &&
            itemDate.getFullYear() === today.getFullYear()
          );
        });
      case "year":
        return data?.groupedRedevances.filter((item) => {
          const itemDate = new Date(item.prochaineMensualite.date);
          return itemDate.getFullYear() === today.getFullYear();
        });
      default:
        return data?.data;
    }
  }, [filter, data]);

  const filteredData = filterData();



  useEffect(() => {
    if (searchTerm) {
      searchRedevances({ page: 1, size: 50, search: searchTerm })
        .then((res) => {
          console.log("searchRedevances response", res);
          setRedevances(
            res?.data?.groupedRedevances?.filter(
              (item) => item.name !== "Inconnu"
            )
          );
        })
        .catch((error) => {
          console.error("Error searching redevances:", error);
          toast.error("Erreur lors de la recherche des redevances.", {
            position: "top-right",
          });
        });
    } else {
      getRedevances({ page: 1, size: 50 })

        .then((res) => {
          console.log("getRedevances response", res);
          setRedevances(
            res?.data?.groupedRedevances?.filter(
              (item) => item.name !== "Inconnu"
            )
          );
        })
        .catch((error) => {
          console.error("Error fetching redevances:", error);
          toast.error("Erreur lors de la récupération des redevances.", {
            position: "top-right",
          });
        });
    }
  }, [searchTerm, getRedevances, searchRedevances]);


  useEffect(() => {
    if (params?.name === "success") {
      savePayment("success");
    }

    if (params?.name === "echec") {
      savePayment("echec");
    }
  }, [params.name]);

  useEffect(() => {
    getRedevances({ page: fetchedPage.page, size: fetchedPage.size })?.then(
      (res) => {
        console.log("getRedevances response", res);
        setRedevances(
          res?.data?.groupedRedevances?.filter(
            (item) => item.name !== "Inconnu"
          )
        );
      }
    );
  }, []);
  console.log("is loading", isLoading);
  console.log("is Success", isSuccess);
  if (isLoading) {
    return <div>Chargement des données...</div>;
  }

  if (isError) {
    return <div>Erreur lors du chargement des données.</div>;
  }

  if (!isSuccess || !data || data.length === 0) {
    return <div>Aucune donnée disponible.</div>;
  }

  return (
    <div className="m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Page" title="Les rédevances" />

      <div className="flex justify-center items-center">
        <div className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg h-44 rounded-xl w-full lg:w-auto p-8 pt-9 m-3 bg-hero-pattern bg-no-repeat bg-cover bg-center">
          <div className="flex justify-between items-center">
            <div>
              <p className="font-bold text-gray-400">
                Nombre total de redevances
              </p>
              <p className="text-2xl font-bold">{data?.totalRedevances}</p>
            </div>
          </div>
          {/* <div className="mt-6">
            <Button
              color="white"
              bgColor={"#d76a2b"}
              text="Télécharger"
              borderRadius="10px"
              size="md"
            />
          </div> */}
        </div>
      </div>

      <div className="w-full flex justify-between mb-4 bg-slate-200 p-2 rounded-2xl shadow-md space-x-3 py-2">
      <div>

      </div>

        <div>
          <span
            onClick={() => setFilter("today")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Aujourd'hui
          </span>
          <span
            onClick={() => setFilter("this_week")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Cette semaine
          </span>
          <span
            onClick={() => setFilter("this_month")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Ce mois
          </span>
          <span
            onClick={() => setFilter("this_year")}
            className="bg-yellow-400 px-4 w-44 text-center py-1 rounded-full hover:bg-yellow-200 shadow-md cursor-pointer font-semibold">
            Cette année
          </span>
        </div>
      </div>

      <GridComponent
        dataSource={
          searchData?.data ||
          (redevances
            ? [...redevances].sort((a, b) => {
                return (
                  new Date(b?.prochaineMensualite?.date) -
                  new Date(a?.prochaineMensualite?.date)
                );
              })
            : [])
        }
        id="Grid"
        height={520} // hauteur fixe
        width="100%" // largeur stable
        rowHeight={38} // hauteur de ligne uniforme (optionnel)
        className="p-4 rounded-2xl  shadow-xl overflow-hidden overflow-y-scroll h-full"
        allowExcelExport={true}
        allowFiltering={true}
        allowPaging={true}
        allowSearching={true}
        toolbarClick={toolbarClick}
        allowSorting
        toolbar={["Search", "ExcelExport"]}
        editSettings={{ allowDeleting: true, allowEditing: true }}
  
        excelExportComplete={excelExportComplete}
        excelQueryCellInfo={excelQueryCellInfo}
        ref={(g) => (grid = g)}>
        <ColumnsDirective>
          {redevancessGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
          <ColumnDirective
            headerText="Action"
            width="50"
            field="action"
            template={paymentTemplate}
            headerTemplate={headerTemplate}
          />
        </ColumnsDirective>

        <Inject
          services={[
            Page,
            Edit,
            Toolbar,
            Sort,
            Selection,
            Filter,
            Search,
            ExcelExport,
          ]}
        />
      </GridComponent>
      <div className="w-full flex justify-end mt-4">
        <Pagination next={next} prev={prev} />
      </div>
      <Modal1 setShow={setShow} show={show}>
        <RedevanceCard item={selected} />
      </Modal1>
    </div>
  );
};

export default Redevances;
